export const validationRequest = async (path, signal, body) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${path}`, {
        method: body ? 'POST' : 'GET',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            Authorization: sessionStorage.getItem('agronetToken'),
            Local: localStorage.getItem('lang') || 'en'
        },
        signal,
        ...(body ? {body: JSON.stringify(body)} : {})
    });
    if (!response.ok) throw new Error(String(response.status));
    return response.json();
};

export const formatValidationDate = (value, locale = 'en') => {
    if (typeof value !== 'string' || !value.trim()) return '—';
    const timestamp = value.trim();
    // Older responses omit the UTC suffix; current responses include it.
    const date = new Date(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(timestamp) ? timestamp : `${timestamp}Z`);
    return Number.isFinite(date.getTime()) ? date.toLocaleString(locale) : '—';
};

export const localDateInput = date => {
    const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return local.toISOString().slice(0, 16);
};

export const buildValidationRequest = (form, superAdmin) => {
    const from = new Date(form.periodFrom);
    const to = new Date(form.periodTo);
    if (!form.periodFrom || !form.periodTo || !Number.isFinite(from.getTime()) ||
        !Number.isFinite(to.getTime()) || from >= to || to > new Date() || to - from > 31 * 86400000) {
        throw new Error('Select an increasing period in the past, up to 31 days.');
    }
    const request = {
        mode: superAdmin ? form.mode : 'USER',
        periodFrom: from.toISOString().slice(0, 19),
        periodTo: to.toISOString().slice(0, 19)
    };
    if (request.mode === 'USER') {
        if (superAdmin && form.userId) request.userId = Number(form.userId);
    } else {
        const lat = Number(form.lat), lon = Number(form.lon);
        const radius = Number(form.radiusKm), max = Number(form.maxSensors);
        const perSite = Number(form.maxSensorsPerSite);
        if (form.lat === '' || form.lon === '' || !Number.isFinite(lat) || !Number.isFinite(lon) ||
            Math.abs(lat) > 90 || Math.abs(lon) > 180 || !(radius > 0 && radius <= 100) ||
            !Number.isInteger(max) || max < 1 || max > 500 ||
            (form.maxSensorsPerSite !== '' && (!Number.isInteger(perSite) || perSite < 1))) {
            throw new Error('Enter valid coordinates and selection limits.');
        }
        Object.assign(request, {lat, lon, radiusKm: radius, maxSensors: max});
        if (form.maxSensorsPerSite !== '') request.maxSensorsPerSite = perSite;
    }
    return request;
};
